interface Listener {
  (expanded: boolean): void;
}

class WorkspaceNavigationExpanded {
  expanded: boolean;
  listeners: Set<Listener> = new Set();

  constructor(initialValue?: boolean) {
    this.expanded = initialValue || false;
  }

  setValue(nextValue: boolean): void {
    this.expanded = nextValue;

    for (const listener of this.listeners) {
      listener(this.expanded);
    }
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const workspaceNavigationExpanded = new WorkspaceNavigationExpanded();
